import React from "react";
import { SignInComponent } from "../components";
import RedirectionComponent from '../components/RedirectionComponent';
export default function SignIn() {
	const [redirect, setRedirect] = React.useState(false)
	React.useEffect(() => {
		const allowedHosts = ["app.factoreal.com", "prime2.factoreal.info", "lbfactgcp.openturf.dev"];
		if (allowedHosts.some(host => window.location.hostname.includes(host))) {
			setRedirect(true)
		}


	}, []);
	return redirect ? <RedirectionComponent /> : <SignInComponent />;
}
